import { render } from "./TabsPage.vue?vue&type=template&id=21104879&scoped=true"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=21104879&lang=scss&scoped=true"

import exportComponent from "/home/dijuno-mobile/dijuno-mobile.pderasapps.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21104879"]])

export default __exports__